
export const Address = [
  {
    id: 1,
    jalan: "RT.05/RW.02, Gambir, Kecamatan Gambir, Kota Jakarta Pusat, Daerah Khusus Ibukota Jakarta",
    kodepos: 10110,
    name: "Rumah",
  },
  {
    id: 2,
    jalan: "Jl. Semolowaru Timur II No.43, Semolowaru, Kec. Sukolilo, Surabaya, Jawa Timur",
    kodepos: 60119,
    name: "Kantor",
  },
  {
    id: 3,
    jalan: "Kertajaya Indah Regency No. 13, Keputih, Kec. Sukolilo, Surabaya, Jawa Timur",
    kodepos: 60111,
    name: "Apartemen",
  },
  {
    id: 4,
    jalan: "PP5P+6X6, Darmo, Kec. Wonokromo, Surabaya, Jawa Timur",
    kodepos: 60241,
    name: "Toko",
  },
]